import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import * as fromOneClickContracts from './one-click-contract.reducer';
import * as fromOneClickJobsites from './one-click-jobsites.reducer';
import * as fromOneClickOrders from './one-click-orders.reducer';
import * as fromOneClickPayments from './one-click-payments.reducer';
import * as fromOneClickPlants from './one-click-plants.reducer';
import * as fromOneClickPods from './one-click-pods.reducer';
import * as fromOneClickProducts from './one-click-products.reducer';
import * as fromOneClickProfile from './one-click-profile.reducer';
import * as fromOneClickQuantity from './one-click-quantity.reducer';
import * as fromOneClickReceivingPerson from './one-click-receiving-person.reducer';
import * as fromOneClickShippingLocationModes from './one-click-shipping-location-mode.reducer';
import * as fromOneClickShippingMethods from './one-click-shipping-method.reducer';
import * as fromOneClickTimeWindows from './one-click-time-windows.reducer';
import * as fromOneClickStdLot from '@ordersnproducts/modules/one-click-order/reducers/one-click-standard-lot.reducer';
import * as fromOneClickBusinessLines from './one-click-business-lines.reducer';
import * as fromOneClickUnits from './one-click-units.reducer';
import * as fromOneClickJobsiteSalesArea from './one-click-jobsite-sales-area.reducer';
import * as fromOneClickAdditionalServicesState from '@ordersnproducts/modules/one-click-order/reducers/one-click-additional-services.reducer';
import * as fromOneClickPurchaseOrderState from './one-click-validate-purchase-order.reducer';
import * as fromOneClickHaulersState from './one-click-haulers.reducer';
import * as fromOneClickVehiclesState from './one-click-vehicles.reducer';
import * as fromOneClickOwnFreightPlantsState from './one-click-ownFreight-plants.reducer';
import * as fromOneClickNextWorkingDayState from './one-click-next-working-day.reducer';
import { State as RootState } from '@cemex/cmx-client-layout';

export interface OneClickState {
  oneClickOrders: fromOneClickOrders.OneClickOrdersState;
  jobsiteState: fromOneClickJobsites.OneClickJobsiteState;
  pointOfDeliveriesState: fromOneClickPods.OneClickPointOfDeliveryState;
  shippingMethodsState: fromOneClickShippingMethods.OneClickShippingMethodState;
  productsState: fromOneClickProducts.OneClickProductsState;
  profileState: fromOneClickProfile.OneClickProfileState;
  paymentsState: fromOneClickPayments.OneClickPaymentsState;
  shippingLocationModes: fromOneClickShippingLocationModes.OneClickShippingLocationModeState;
  plansState: fromOneClickPlants.OneClickPlantsState;
  unitsSate: fromOneClickUnits.OneClickUnitsState;
  quantityState: fromOneClickQuantity.OneClickQuantityState;
  receivingPersonState: fromOneClickReceivingPerson.OneClickReceivingPersonState;
  timeWindowsState: fromOneClickTimeWindows.OneClickTimeWindowsState;
  stdLotState: fromOneClickStdLot.OneClickStandardLotState;
  businessLinesState: fromOneClickBusinessLines.OneClickBusinnesLinesState;
  contractState: fromOneClickContracts.OneClickContractsState;
  jobsiteSalesAreaState: fromOneClickJobsiteSalesArea.OneClickJobsiteSalesAreaState;
  additionalServicesState: fromOneClickAdditionalServicesState.OneClickAdditionalServicesState;
  purchaseOrderState: fromOneClickPurchaseOrderState.OneClickPurchaseOrderState;
  haulersState: fromOneClickHaulersState.OneClickHaulersState;
  vehiclesState: fromOneClickVehiclesState.OneClickVehiclesState;
  ownFreightPlantsState: fromOneClickOwnFreightPlantsState.OneClickOwnFreightPlantsState;
  nextWorkingDayState: fromOneClickNextWorkingDayState.OneClickNextWorkingDayState;
}

export interface State extends RootState {
  oneClick: OneClickState;
}

export const reducers: ActionReducerMap<OneClickState> = {
  oneClickOrders: fromOneClickOrders.reducer,
  jobsiteState: fromOneClickJobsites.reducer,
  pointOfDeliveriesState: fromOneClickPods.reducer,
  shippingMethodsState: fromOneClickShippingMethods.reducer,
  productsState: fromOneClickProducts.reducer,
  profileState: fromOneClickProfile.reducer,
  paymentsState: fromOneClickPayments.reducer,
  shippingLocationModes: fromOneClickShippingLocationModes.reducer,
  plansState: fromOneClickPlants.reducer,
  unitsSate: fromOneClickUnits.reducer,
  quantityState: fromOneClickQuantity.reducer,
  receivingPersonState: fromOneClickReceivingPerson.reducer,
  timeWindowsState: fromOneClickTimeWindows.reducer,
  stdLotState: fromOneClickStdLot.reducer,
  businessLinesState: fromOneClickBusinessLines.reducer,
  contractState: fromOneClickContracts.reducer,
  jobsiteSalesAreaState: fromOneClickJobsiteSalesArea.reducer,
  additionalServicesState: fromOneClickAdditionalServicesState.reducer,
  purchaseOrderState: fromOneClickPurchaseOrderState.reducer,
  haulersState: fromOneClickHaulersState.reducer,
  vehiclesState: fromOneClickVehiclesState.reducer,
  ownFreightPlantsState: fromOneClickOwnFreightPlantsState.reducer,
  nextWorkingDayState: fromOneClickNextWorkingDayState.reducer,
};

/**
 * The createFeatureSelector function selects a piece of state from the root of the state object.
 * This is used for selecting feature states that are loaded eagerly or lazily.
 */
export const getOneClickState = createFeatureSelector<OneClickState>('oneClick');
